"use client";
import PageContent from "./PageContent";
import { PageTypes } from "@lib/enums/PageTypes";
import { DefaultLayout } from "@app/DefaultLayout";
import { ErrorPageContent } from "@components/errors/ErrorPageContent";
import { useGlobalContent } from "@app/[locale]/GlobalContentProvider";
import { useEffect } from "react";
import { Logger, LogTag, ServiceType } from "@lib/monitoring/logger";
/*
The error.tsx page has to be a client component and as such cannot fetch data on the server.
Instead we fetch it from an API route.
*/
export default function ErrorPage({ error }: { error: Error & { digest?: string } }) {
    useEffect(() => {
        Logger.error(ServiceType.WEB, "Global error page", {
            tag: LogTag.ERROR,
            error: Logger.errorToJson(error),
        });
    }, [error]);

    const { siteSettings } = useGlobalContent();

    if (!siteSettings) {
        return <ErrorPageContent />;
    }

    return (
        <PageContent pageType={PageTypes.ERROR}>
            <DefaultLayout>
                <ErrorPageContent />
            </DefaultLayout>
        </PageContent>
    );
}
